import PropTypes from 'prop-types';
import * as S from './ExcludeSettings.styled';
import { Buttons } from 'components';
import { DeleteIcon } from 'assets/icons';
import { addUniqueIds } from 'utils';
import { PackageNameInput, ParagraphWithTooltip } from 'components';
import { cloneDeep } from 'lodash-es';

const ExcludePackageName = ({ onChange, value }) => {
  const selectedPackageNames = addUniqueIds(value);

  const clearAll = () => {
    onChange([]);
  };

  const deletePackage = (id) => {
    let newData = cloneDeep(selectedPackageNames);
    newData = newData.filter((item) => item.id !== id);
    onChange(newData);
  };

  return (
    <>
      <S.TextField>
        <S.Title>Exclude Packages or store IDs:</S.Title>
      </S.TextField>
      <S.FieldsWrap>
        <S.PackageNamesActionField>
          <PackageNameInput
            selectedPackageNames={selectedPackageNames}
            setSelectedPackageName={onChange}
          />
          {selectedPackageNames?.length > 0 && (
            <S.PackageNamesWrap>
              <Buttons.TertiaryNormal id='package_names_clear_all' onClick={clearAll}>
                Clear All
              </Buttons.TertiaryNormal>
              <S.Wrap>
                <S.SelectedItem>
                  {selectedPackageNames?.map((item) => (
                    <S.Item key={item?.id} height='32px' line>
                      <S.Column>
                        <ParagraphWithTooltip text={item?.package_id} />
                      </S.Column>
                      <S.IconWrapp onClick={() => deletePackage(item?.id)}>
                        <DeleteIcon />
                      </S.IconWrapp>
                    </S.Item>
                  ))}
                </S.SelectedItem>
              </S.Wrap>
            </S.PackageNamesWrap>
          )}
        </S.PackageNamesActionField>
      </S.FieldsWrap>
    </>
  );
};

ExcludePackageName.propTypes = {
  //value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ExcludePackageName;
